import { Label } from "@/components/ui/label";

export const Field = ({ label, hint, children }) => (
  <div className="mb-4">
    <Label className="text-xs uppercase tracking-wider">{label}</Label>
    {children}
    {hint && <p className="text-xs text-muted-foreground mt-1">{hint}</p>}
  </div>
);
